<template>
  <div class="home">
    <!-- 轮播图 -->
    <div class="banner">
      <div id="carouselExampleControls" class="carousel slide" data-ride="carousel" v-if="banners && banners.length > 0">
        <div class="carousel-inner">
          <div 
            v-for="(banner, index) in banners" 
            :key="index"
            :class="['carousel-item', { active: index === 0 }]"
          >
            <a href="tel:15392850129" class="img-phone-link">
              <img 
                :src="banner.imgUrl" 
                alt="轮播图片" 
                class="d-block w-100 img-fluid"
                :style="{ height: bannerHeight }"
              >
            </a>
            <!-- <div class="carousel-caption d-none d-md-block">
              <h5>{{ banner.title }}</h5>
              <p>{{ banner.description }}</p>
            </div> -->
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">上一张</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">下一张</span>
        </a>
      </div>
    </div>

    <!-- 产品特性 -->
    <!-- <section class="features">
      <div class="container">
        <div class="row feature-list">
          <div class="col-md-3 col-6">
            <div class="feature-item">
              <div class="feature-icon">
                <img src="../assets/images/home_icon_05.png" alt="节省人员">
              </div>
              <h4>节省人员</h4>
              <p>通过禾销系统帮助企业节省50%人力成本</p>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="feature-item">
              <div class="feature-icon">
                <img src="../assets/images/home_icon_06.png" alt="减少工作">
              </div>
              <h4>减少工作</h4>
              <p>自动化流程将工作效率提升80%</p>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="feature-item">
              <div class="feature-icon">
                <img src="../assets/images/home_icon_07.png" alt="节省时间">
              </div>
              <h4>节省时间</h4>
              <p>通过智能管理系统，减少手动操作时间，提升工作效率</p>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="feature-item">
              <div class="feature-icon">
                <img src="../assets/images/home_icon_08.png" alt="减少损耗">
              </div>
              <h4>减少损耗</h4>
              <p>通过智能管理系统，减少资源浪费，提升效率</p>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- 禾苗产品 -->
    <section class="products">
      <div class="container">
        <div class="section-header text-center">
          <h2>禾销 - 专业导购激励政策与核销工具平台</h2>
          <p>服务10万+导购员，覆盖4万+门店，一站式解决导购激励落地难题</p>
        </div>
        <div class="row product-list">
          <div class="col-md-12">
            <div class="product-item">
              <a href="tel:15392850129" class="product-link img-phone-link">
                <img 
                  src="../assets/images/home_web_03.png" 
                  alt="禾销导购激励政策平台" 
                  class="product-img img-fluid" 
                  style="max-width: 100%; height: auto; object-fit: contain;"
                >
                <div class="product-info">
                  <h3>导购激励政策定制</h3>
                  <p>灵活制定导购激励方案，自动发放激励红包，节省50%人工操作成本</p>
                  <span class="more">了解更多 →</span>
                </div>
              </a>
            </div>
          </div>
          <div class="col-md-12">
            <div class="product-item">
              <a href="tel:15392850129" class="product-link img-phone-link">
                <img 
                  src="../assets/images/home_web_04.png" 
                  alt="我要核销功能示意图" 
                  class="product-img img-fluid" 
                  style="max-width: 100%; height: auto; object-fit: contain;"
                >
                <div class="product-info">
                  <h3>我要核销 - 智能费用管理</h3>
                  <p>导购费用线上化核销，系统自动审核，提升核销效率80%，确保财务合规</p>
                  <span class="more">了解更多 →</span>
                </div>
              </a>
            </div>
          </div>
          <div class="col-md-12">
            <div class="product-item">
              <a href="tel:15392850129" class="product-link img-phone-link">
                <img 
                  src="../assets/images/home_web_05.png" 
                  alt="导购激励数据看板" 
                  class="product-img img-fluid" 
                  style="max-width: 100%; height: auto; object-fit: contain;"
                >
                <div class="product-info">
                  <h3>动销数据实时监控</h3>
                  <p>实时追踪导购激励效果，数据驱动营销决策，及时调整激励策略</p>
                  <span class="more">了解更多 →</span>
                </div>
              </a>
            </div>
          </div>
          <div class="col-md-12">
            <div class="product-item">
              <a href="tel:15392850129" class="product-link img-phone-link">
                <img 
                  src="../assets/images/home_web_06.png" 
                  alt="费用核销流程" 
                  class="product-img img-fluid" 
                  style="max-width: 100%; height: auto; object-fit: contain;"
                >
                <div class="product-info">
                  <h3>费用精准发放</h3>
                  <p>智能防作弊系统，确保导购激励费用精准发放，减少资金损耗风险</p>
                  <span class="more">了解更多 →</span>
                </div>
              </a>
            </div>
          </div>
          <div class="col-md-12">
            <div class="product-item">
              <a href="tel:15392850129" class="product-link img-phone-link">
                <img 
                  src="../assets/images/home_web_07.png" 
                  alt="导购激励发放保障" 
                  class="product-img img-fluid" 
                  style="max-width: 100%; height: auto; object-fit: contain;"
                >
                <div class="product-info">
                  <h3>发放保障承诺</h3>
                  <p>发错包赔</p>
                  <span class="more">了解更多 →</span>
                </div>
              </a>
            </div>
          </div>
          <div class="col-md-12">
            <div class="product-item">
              <a href="tel:15392850129" class="product-link img-phone-link">
                <img 
                  src="../assets/images/home_web_08.png" 
                  alt="动销数据提升效果" 
                  class="product-img img-fluid" 
                  style="max-width: 100%; height: auto; object-fit: contain;"
                >
                <div class="product-info">
                  <h3>数据驱动动销提升</h3>
                  <p>基于导购行为数据分析，优化激励策略，助力门店动销率提升30%+</p>
                  <span class="more">了解更多 →</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业优势 -->
    <section class="advantages">
      <div class="container">
        <div class="section-header text-center">
          <h2>禾销平台核心优势</h2>
          <p>深耕母婴、美妆零售行业，为500+品牌企业提供专业的导购激励解决方案</p>
        </div>
        <div class="row advantage-list">
          <div class="col-md-12 text-center">
            <a href="tel:15392850129" class="img-phone-link">
              <img 
                src="../assets/images/home_20.png" 
                alt="禾销平台核心优势" 
                class="advantage-img img-fluid mx-auto"
                style="max-width: 100%; height: auto;"
              >
            </a>
          </div>
        </div>
        <div class="row advantage-list">
          <div class="col-md-12 text-center">
            <a href="tel:15392850129" class="img-phone-link">
              <img 
                src="../assets/images/home_web_10.png" 
                alt="禾销平台核心优势" 
                class="advantage-img img-fluid mx-auto"
                style="max-width: 100%; height: auto;"
              >
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      banners: [
        {
          imgUrl: require('../assets/images/banner22.png'),
          title: '禾销 - 专业导购激励政策与核销工具平台',
          description: '专注母婴、美妆零售行业，服务10万+导购员，覆盖4万+门店，解决导购激励发放与合规核销难题'
        },
         {
          imgUrl: require('../assets/images/home_web_09.png'),
          title: '我要核销 - 智能费用核销系统',
          description: '导购费用线上化核销，合规透明，提升效率80%'
        }
      ],
      bannerHeight: '400px'
    }
  },
  mounted() {
    // 响应式调整轮播图高度
    this.adjustBannerHeight()
    window.addEventListener('resize', this.adjustBannerHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustBannerHeight)
  },
  methods: {
    adjustBannerHeight() {
      if (window.innerWidth < 768) {
        this.bannerHeight = 'auto'
      } else if (window.innerWidth < 992) {
        this.bannerHeight = '400px'
      } else {
        this.bannerHeight = '600px'
      }
    }
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
}

/* 轮播图样式 */
.banner {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel-item img {
  object-fit: cover;
  transition: transform 0.5s ease;
  margin: 0 auto;
}

/* 手机端banner图自适应样式 */
@media (max-width: 767px) {
  .carousel-item img {
    object-fit: contain;
    height: auto !important;
    width: 100% !important;
    margin: 0 auto;
  }
  
  .banner {
    background-color: #f8f9fa;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.carousel-item:hover img {
  transform: scale(1.05);
}

.img-phone-link {
  display: inline-block;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.carousel-caption {
  background-color: rgba(0, 0, 0, 0.5);
  padding: 1.5rem;
  border-radius: 8px;
}

.carousel-caption h5 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.carousel-caption p {
  font-size: 1.25rem;
}

/* 特性样式 */
.features {
  padding: 4rem 0;
  background-color: #f8f9fa;
}

.feature-list {
  margin: 0 -15px;
}

.feature-item {
  text-align: center;
  padding: 2rem 1rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  height: 100%;
}

.feature-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.feature-icon {
  margin-bottom: 1.5rem;
}

.feature-icon img {
  width: 80px;
  height: 80px;
}

.feature-item h4 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.feature-item p {
  color: #666;
  font-size: 1rem;
  line-height: 1.6;
}

/* 产品样式 */
.products {
  padding: 5rem 0;
}

.section-header {
  margin-bottom: 3rem;
}

.section-header h2 {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 1rem;
  position: relative;
  display: inline-block;
}

.section-header h2::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: #007bff;
}

.section-header p {
  font-size: 1.2rem;
  color: #666;
  margin-top: 1.5rem;
}

.product-item {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  height: 100%;
}

.product-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.product-link {
  display: block;
  text-decoration: none;
}

.product-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.product-item:hover .product-img {
  transform: scale(1.1);
}

.product-info {
  padding: 1.5rem;
}

.product-info h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
}

.product-info p {
  color: #666;
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.more {
  color: #007bff;
  font-weight: 500;
  font-size: 1rem;
  transition: color 0.3s ease;
}

.more:hover {
  color: #0056b3;
}

/* 优势样式 */
.advantages {
  padding: 5rem 0;
  background-color: #f8f9fa;
}

.advantage-img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.advantage-items {
  list-style: none;
  padding: 0;
  margin: 0;
}

.advantage-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.advantage-item:hover {
  transform: translateX(10px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.advantage-icon {
  margin-right: 1.5rem;
  color: #007bff;
  font-size: 2rem;
}

.advantage-text h4 {
  font-size: 1.25rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.advantage-text p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 0;
}

/* 响应式设计 */
@media (max-width: 767px) {
  .carousel-caption h5 {
    font-size: 1.5rem;
  }
  
  .carousel-caption p {
    font-size: 1rem;
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
  
  .section-header p {
    font-size: 1rem;
  }
  
  .product-img {
    height: 180px;
  }
  
  .advantage-img {
    margin-bottom: 2rem;
  }
}

@media (max-width: 575px) {
  .feature-item {
    margin-bottom: 1rem;
  }
  
  .product-item {
    margin-bottom: 1.5rem;
  }
}
</style>